import * as React from "react"
import styles from "./ShareFIlters.module.scss"
import SelectBox from "../SelectBox/SelectBox";
import Button from "../mainButton/Button";
import {getCurrentFilters} from "../../../util/currentFiltersHelper";
import {usePost} from "../../../hooks/usePost.hook";
import {useContext, useEffect} from "react";
import appContext from "../../../context/appContext";
import {useFetch} from "../../../hooks/useFetch.hook";
import ModalBox from "../ModalBox/ModalBox";
import {notificationManager} from "../Notification/NotificationManager";
import {getUniqueListBy} from "../../../util/util";

const ShareFilters = ({selectedColumn}) => {

  const [userManagementData, setUserManagementData] = React.useState([])
  const [selectedUsers, setSelectedUsers] = React.useState([])
  const [showDropdown, setShowDropdown] = React.useState(false)
  const [hasSharedBefore, setHasSharedBefore] = React.useState(false)
  const [postSharingApiCall, setPostSharingApiCall] = React.useState(false)
  const [updateSharingApiCall, setUpdateSharingApiCall] = React.useState(false)
  const [dontUpdateFilters, setDontUpdateFilters] = React.useState(false)
  const [showUpdateChangesModal, setShowUpdateChangesModal] = React.useState(false)
  const [userManagementPage, setUserManagementPage] = React.useState(1)
  const [searchResult, setSearchResult] = React.useState([])
  const [searchValue, setSearchValue] = React.useState(null)
  const [url, setUrl] = React.useState(`authentication/user_management/?page=1`)

  const context = useContext(appContext)

  const usersData = useFetch(url)

  React.useEffect(() => {
    if (usersData?.data?.results?.length) {
      const users = userManagementData?.length ? [...userManagementData, ...usersData?.data?.results] : usersData?.data?.results
      setUserManagementData(users?.filter(item =>( item.is_active && item.verification_status === "verified") || item.role === "admin"))
    }
  }, [usersData?.data?.results])

  const passData = {
    filters: getCurrentFilters(context, "/data-analysis"),
    analysis: context.handleUid().id,
    column_name: selectedColumn?.toUpperCase(),
    users: selectedUsers
  }

  const sharedData = useFetch(`sharing/data_analysis/${context.handleUid().id}`)

  useEffect(() => {
    setUserManagementData([])
    setSelectedUsers(null)
    setUrl(`authentication/user_management/?page=1`)
    setUserManagementPage(1)
    sharedData.refetch()
    handleFetchUsersData()

    return () => {
      setUserManagementData([])
      setSelectedUsers(null)
    }
  }, [])

  useEffect(() => {
    if (sharedData.data && userManagementData?.length) {
      setSelectedUsers(sharedData?.data?.users)
      if (sharedData.data) {
        setHasSharedBefore(true)
      }
    }
  }, [sharedData.data, userManagementData])

  let { data, status } = usePost("post", `sharing/`, passData, postSharingApiCall)

  const apiUpdateSharedLink = usePost("put",`sharing/${sharedData.data?.id}/`, dontUpdateFilters ? {...sharedData.data, users: passData.users} : passData, updateSharingApiCall)

  useEffect(() => {
    if (!apiUpdateSharedLink.status.isSending) {
      setDontUpdateFilters(false)
      setUpdateSharingApiCall(false)

      if (apiUpdateSharedLink.status.isSuccess) {
        setPostSharingApiCall(false)
        navigator.clipboard.writeText(`${window.origin}/share/data_analysis/${sharedData.data.id}`)
        notificationManager.show({
          title: "Copied to Clipboard",
          content: "",
        });
      }
    }
  }, [apiUpdateSharedLink.status.isSending])

  useEffect(() => {
    if (!status.isSending) {
      setDontUpdateFilters(false)
      setUpdateSharingApiCall(false)
      if (status.isSuccess) {
        navigator.clipboard.writeText(`${window.origin}/share/data_analysis/${data.id}`)
        notificationManager.show({
          title: "Copied to Clipboard",
          content: "",
        });
      }
    }
  }, [status.isSending])

  useEffect(() => {
    if ((status.isError || status.isSuccess) && postSharingApiCall) {
      setPostSharingApiCall(false)
      if (status.isSuccess) {
        sharedData.refetch()
      }
    }
  }, [postSharingApiCall, status])

  const headerTemplate = <header className={styles.header}>
    Share Data Analysis
  </header>

  const createOrUpdateLink = () => {
    if (hasSharedBefore) {
      setUpdateSharingApiCall(true)
    } else {
      setPostSharingApiCall(true)
    }
  }

  const handleFetchUsersData = (searchValue) => {
    if (usersData?.data && userManagementPage < usersData?.data?.total_pages) {
      setUserManagementPage(userManagementPage + 1)
      setUrl(`authentication/user_management/?page=${userManagementPage + 1}`)
      if (searchValue) {
        setUrl(`authentication/user_management/?page=${userManagementPage + 1}&search=${searchValue}`)
      }
    }
  }

  const customButtons = <div className={'d-flex justify-content-between'}>
    <div className={'flex-grow-1'}>
      <Button block type={"outlined"} color={"primary"}
              size={"small"}
              onClick={() => hasSharedBefore ? setShowUpdateChangesModal(true) : setPostSharingApiCall(true)}
      >
        {hasSharedBefore ? "Update Changes to Link" : "Copy Link to Clipboard"}
      </Button>
    </div>
    {
      hasSharedBefore &&  <div className={'flex-grow-1 ml-3'}>
        <Button block type={"outlined"} color={"primary"}
                size={"small"}
                onClick={() => {
                  navigator.clipboard.writeText(`${window.origin}/share/data_analysis/${sharedData.data.id}`)
                  notificationManager.show({
                    title: "Copied to Clipboard",
                    content: "",
                  });
                }}
        >
          Copy Current Link
        </Button>
      </div>
    }
  </div>

  return (
    <>
      <div className={styles.shareFilters}>
        <div onClick={() => setShowDropdown(!showDropdown)} className={[styles.shareFiltersButton, showDropdown && styles.showDropdown, "d-flex align-items-center justify-content-center cursor-pointer"].join(' ')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.868 19.9814C12.2045 21.101 9.11737 20.562 6.9832 18.5986C8.786 16.689 7.44392 13.5097 4.78916 13.5097C3.12459 13.5097 1.77039 14.8639 1.77039 16.5284C1.77039 18.5768 3.78084 20.0384 5.73134 19.3958C8.29206 21.9641 12.1381 22.6939 15.427 21.3114C15.7943 21.157 15.9669 20.7342 15.8125 20.3669C15.6581 19.9996 15.2353 19.8271 14.868 19.9814V19.9814ZM3.21309 16.5284C3.21309 15.6594 3.92011 14.9524 4.78916 14.9524C5.65817 14.9524 6.36523 15.6594 6.36523 16.5284C6.36523 17.3974 5.65821 18.1045 4.78916 18.1045C3.92011 18.1045 3.21309 17.3974 3.21309 16.5284Z" fill="#0A195C"/>
            <path d="M4.11229 11.0485C4.48812 11.1852 4.90109 10.9901 5.0368 10.6172C5.75522 8.64223 7.31249 7.04677 9.25347 6.26897C9.72974 7.31119 10.7813 8.03755 12.0001 8.03755C13.6646 8.03755 15.0188 6.68334 15.0188 5.01878C15.0188 3.35425 13.6646 2 12.0001 2C10.4003 2 9.08787 3.2511 8.9881 4.82613C6.51814 5.72178 4.57247 7.67331 3.68097 10.124C3.54481 10.4984 3.73791 10.9123 4.11229 11.0485V11.0485ZM12.0001 3.44271C12.8691 3.44271 13.5761 4.14972 13.5761 5.01878C13.5761 5.88783 12.8691 6.59484 12.0001 6.59484C11.131 6.59484 10.424 5.88783 10.424 5.01878C10.424 4.14972 11.1311 3.44271 12.0001 3.44271V3.44271Z" fill="#0A195C"/>
            <path d="M20.8094 13.9695C20.8348 13.8264 20.8499 13.3659 20.8499 13.1496C20.8499 10.6487 19.7842 8.25309 17.9263 6.57684C17.6305 6.31003 17.1743 6.33343 16.9074 6.62923C16.6406 6.92503 16.664 7.38115 16.9598 7.64805C18.587 9.11605 19.5075 11.261 19.3978 13.516C17.6443 13.4081 16.1919 14.807 16.1919 16.5285C16.1919 18.193 17.5461 19.5472 19.2107 19.5472C20.8753 19.5472 22.2295 18.193 22.2295 16.5285C22.2295 15.4507 21.6614 14.5037 20.8094 13.9695V13.9695ZM19.2107 18.1045C18.3417 18.1045 17.6347 17.3975 17.6347 16.5284C17.6347 15.6594 18.3417 14.9523 19.2107 14.9523C20.0798 14.9523 20.7868 15.6594 20.7868 16.5284C20.7868 17.3975 20.0798 18.1045 19.2107 18.1045V18.1045Z" fill="#0A195C"/>
          </svg>
        </div>
        <div>
          <SelectBox
            propsSearchUrl={"authentication/user_management/?page=1&search"}
            searchByApi
            searchResult={searchResult}
            onSearchResult={(result, val) => {
              if (result) {
                const sr = result?.data?.results?.filter(user => (user.is_active && user.verification_status === "verified") || user.role === "admin")?.map(user => ({title: user.username, value: user.id}))
                searchResult?.length ? setSearchResult(getUniqueListBy([...searchResult, ...sr])) : setSearchResult(sr)
                setSearchValue(val)
                setUserManagementPage(1)
                setUserManagementData(result?.data?.results)
              } else {
                setUserManagementData([])
                setSearchResult([])
                setSearchValue(null)
                setUserManagementPage(1)
                setTimeout(() => {
                  setUrl(null)
                }, 0)
                setTimeout(() => {
                  setUrl(`authentication/user_management/?page=1`)
                }, 0)
                setTimeout(() => {
                  sharedData.refetch()
                }, 500)
              }
            }}
            infiniteScroll
            onFetchData={() => handleFetchUsersData(searchValue)}
            customButtons={customButtons}
            searchStyle={"secondary"}
            header={headerTemplate}
            showDropdown={showDropdown}
            onCloseDropdown={setShowDropdown}
            optionsStyle={{left: -360, maxHeight: 371}}
            optionsContainerWidth={400}
            showInput={false}
            multiSelect
            block
            options={userManagementData?.map(user => ({title: user.username, value: user.id}))}
            dropDownValue={selectedUsers || []}
            onSelectOption={(options) => setSelectedUsers(options)}
          />
        </div>
      </div>
      <ModalBox showModal={showUpdateChangesModal} type={"dialog"} fixedSize={480} title={"Update Changes"} onSubmit={() => {
        createOrUpdateLink()
        setShowUpdateChangesModal(false)
      }} handleTriggerShowModal={() => setShowUpdateChangesModal(false)} onCancel={() => {
        createOrUpdateLink()
        setDontUpdateFilters(true)
        setShowUpdateChangesModal(false)
      }} submitText={"Yes, Update Filters & Users"} cancelText={"No, Just Update Users"}>
        <p>
          There have also been changes to filters. Would you like to apply the filter changes to the link as well?
        </p>
      </ModalBox>
    </>
  )
}

export default ShareFilters